<template>
    <v-container>
        <v-row text-center wrap>
            <v-col xs="12">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Расписание</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            v-if="!timetable.loading"
                            @click="updateTimetablePopup"
                        >
                            Рабочее время: {{  timetable.data.start }} - {{ timetable.data.end }}
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-row>
                            <v-col
                                v-for="m in months"
                                :key="m.format('MMMM')"
                                md="4"
                            >
                                <v-card elevation="0">
                                    <v-card-title class="text-capitalize">{{ m.format('MMMM, YYYY') }}</v-card-title>
                                    <v-card-text>
                                        <v-calendar
                                            :value="m.format('YYYY-MM-DD')"
                                            @click:day="updateSchedule"
                                            type="month"
                                            :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                                            :show-month-on-first="false"
                                        >
                                            <template v-slot:day="{ date }">
                                                <div class="text-center mb-3 event">
                                                    <span v-if="search.data.includes(date)">🔴</span>
                                                    <span v-else-if="!search.loading">🟢</span>
                                                    <span v-else style="opacity: 0.1">🟢</span>
                                                </div>
                                            </template>
                                        </v-calendar>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog
            v-if="timetable.show"
            v-model="timetable.show"
            max-width="650"
        >
            <v-card>
                <v-card-title class="headline">Рабочее время</v-card-title>
                <v-form
                    @submit.prevent="updateTimetable"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-row>
                            <v-col md="6" class="pl-5">
                                <v-time-picker
                                    v-model="timetable.data.start"
                                    :max="timetable.data.end"
                                    format="24hr"
                                    locale="ru"
                                    color="primary"
                                    @input="timetable.errors.start = []"
                                ></v-time-picker>
                            </v-col>
                            <v-col md="6" class="mr-0">
                                <v-time-picker
                                    v-model="timetable.data.end"
                                    :min="timetable.data.start"
                                    format="24hr"
                                    locale="ru"
                                    color="primary"
                                    @input="timetable.errors.end = []"
                                ></v-time-picker>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="timetable.show = false"
                            :disabled="timetable.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="timetable.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: "ScheduleController",
    data () {
        return {
            timetable: {
                data: {
                    start: '',
                    end: '',
                },
                errors: {
                    start: [],
                    end: [],
                },
                loading: true,
                progress: false,
                show: false,
            },
            search: {
                data: [],
                loading: true,
            },
        }
    },
    computed: {
        months () {
            return [
                this.$moment(),
                this.$moment().add('1', 'months'),
                this.$moment().add('2', 'months'),
                this.$moment().add('3', 'months'),
                this.$moment().add('4', 'months'),
                this.$moment().add('5', 'months'),
                this.$moment().add('6', 'months'),
                this.$moment().add('7', 'months'),
                this.$moment().add('8', 'months'),
                this.$moment().add('9', 'months'),
                this.$moment().add('10', 'months'),
                this.$moment().add('11', 'months'),
            ]
        },
    },
    created () {
        this.searchSchedule()
        this.searchTimetable()
    },
    methods: {
        searchSchedule () {
            this.search.loading = true

            this.$axios.post('/manager/schedule/search')
                .then(res => {
                    if (res.data.success) {
                        this.search.data = res.data.data
                    }

                    this.search.loading = false
                })
                .catch(() => {
                    this.search.loading = false
                })
        },

        searchTimetable () {
            this.timetable.loading = true

            this.$axios.post('/manager/schedule/timetable/search')
                .then(res => {
                    if (res.data.success) {
                        this.timetable.data = res.data.data
                    }

                    this.timetable.loading = false
                })
                .catch(() => {
                    this.timetable.loading = false
                })
        },

        updateSchedule (date) {
            this.$axios.post('/manager/schedule/update', {date: date.date})
                .then((res) => {
                    if (res.data.success) {
                        this.search.data = res.data.data
                    } else {
                        this.searchSchedule()
                    }
                })
                .catch(() => {
                    this.searchSchedule()
                })
        },

        updateTimetable () {
            this.timetable.progress = true

            this.$axios.post('/manager/schedule/timetable/update', this.timetable.data)
                .then((res) => {
                    if (res.data.success) {
                        this.timetable.show = false
                    } else {
                        this.timetable.errors.date = res.data.errors.date || []
                    }

                    this.timetable.progress = false
                })
                .catch(() => {
                    this.timetable.progress = false
                })
        },

        updateTimetablePopup: function () {
            this.timetable.show = true
        },
    },
}
</script>

<style>
a {
    text-decoration: none;
}

.event {
    cursor: pointer;
}
</style>